import { render, staticRenderFns } from "./ClientContactPersonPopup.vue?vue&type=template&id=0deacce0&scoped=true&"
import script from "./ClientContactPersonPopup.vue?vue&type=script&lang=js&"
export * from "./ClientContactPersonPopup.vue?vue&type=script&lang=js&"
import style0 from "./ClientContactPersonPopup.vue?vue&type=style&index=0&id=0deacce0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0deacce0",
  null
  
)

export default component.exports